import AddFeedbackTech from "./AddFeedbackTech";

const AddInvFeedbackTech = () => {
  return <AddFeedbackTech isEdit={false} />;
};

export default AddInvFeedbackTech;
